const state = {
  width: 0,
  height: 0,
}

const getters = {
  // information: state => {
  //   return state.information
  // }
}

const mutations = {
  setDimension(state, payload) {
    state.width = payload.width
    state.height = payload.height
  },
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
